/**
 * Types RBAC (Role-Based Access Control)
 * Rôles et permissions pour le système d'autorisation
 */

// Rôles des utilisateurs
export const Role = {
  ADMIN: 'admin',
  CHEF_PROJET: 'chef_projet',
  CLIENT: 'client',
  PRESTATAIRE: 'prestataire',
} as const;

export type Role = typeof Role[keyof typeof Role];

// Permissions par rôle
export const Permission = {
  // Permissions Admin
  VIEW_ALL_PROJECTS: 'view_all_projects',
  MANAGE_USERS: 'manage_users',
  MANAGE_CLIENTS: 'manage_clients',
  MANAGE_PRESTATAIRES: 'manage_prestataires',
  VALIDATE_INVOICES: 'validate_invoices',
  VIEW_FINANCIALS: 'view_financials',
  MANAGE_SETTINGS: 'manage_settings',

  // Permissions Chef de Projet (comportement par défaut toujours actif)
  VIEW_ASSIGNED_PROJECTS: 'view_assigned_projects',
  EDIT_PROJECT_METRICS: 'edit_project_metrics',
  VIEW_PROJECT_STATUS: 'view_project_status',
  VIEW_KEY_METRICS: 'view_key_metrics',

  // Permissions Chef de Projet (optionnelles, personnalisables)
  VIEW_PROJECT_INVOICES: 'view_project_invoices',
  VIEW_MARGINS: 'view_margins',
  CREATE_PROVIDER: 'create_provider',
  ACT_AS_PROVIDER: 'act_as_provider',

  // Permissions Client
  VIEW_OWN_PROJECTS: 'view_own_projects',

  // Permissions Prestataire
  UPLOAD_INVOICES: 'upload_invoices',
  VIEW_OWN_INVOICES: 'view_own_invoices',
  VIEW_PAYMENT_STATUS: 'view_payment_status',

  // Nouvelles permissions RBAC
  EDIT_EDITORIAL_CALENDAR: 'edit_editorial_calendar',
  VIEW_BUDGET_DETAILS: 'view_budget_details',
  VIEW_AGENCY_FEES: 'view_agency_fees',
  /** Page « Marges » : marges obtenues et utilisées de tous les projets */
  VIEW_MARGINS_OVERVIEW: 'view_margins_overview',

  // Permissions d'accès aux dashboards (pour routing)
  ACCESS_ADMIN_DASHBOARD: 'access_admin_dashboard',
  ACCESS_CHEF_DASHBOARD: 'access_chef_dashboard',
  ACCESS_CLIENT_DASHBOARD: 'access_client_dashboard',
  ACCESS_PROVIDER_DASHBOARD: 'access_provider_dashboard',
} as const;

export type Permission = typeof Permission[keyof typeof Permission];
